import React, { useRef } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { AnimatePresence, motion } from 'framer-motion';

interface AnimatedDigitProps {
  digit: number;
  index: number;
}

interface AnimatedDigitWrapperProps extends AnimatedDigitProps {}

const AnimatedDigit: React.FC<AnimatedDigitProps> = ({ digit, index }) => (
  <AnimatePresence>
    <motion.span
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -20, opacity: 0 }}
      transition={{ delay: 0.1 * index, duration: 0.4 }}
      className='absolute inset-0'
      key={digit}
    >
      {digit}
    </motion.span>
  </AnimatePresence>
);

const AnimatedDigitWrapper: React.FC<AnimatedDigitWrapperProps> = ({ digit, index, ...props }) => (
  <div className='relative'>
    <div className='invisible w-auto'>{digit}</div>
    <AnimatedDigit digit={digit} index={index} />
  </div>
);

interface CounterProps {
  end: string;
}

const CounterSlow: React.FC<CounterProps> = ({ end }) => {
  // const [digits, setDigits] = useState<string[]>([]);
  const ref = useRef<HTMLDivElement>(null);

  const digits = end?.split('');

  return (
    <div className='flex' ref={ref}>
      {digits.map((digit, index) => (!isNaN(+digit) ? <AnimatedDigitWrapper key={index} index={index} digit={Number(digit)} /> : digit))}
    </div>
  );
};

export default CounterSlow;
